//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    attribute: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    bucket: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  computed: {
    options() {
      const options = this.bucket.value_enumeration_multi?.buckets.map((b) => b.key) || [];

      options.sort((a, b) => a.localeCompare(b));
      return options;
    },
  },
  methods: {
    select(event) {
      let selected = [...this.value];

      if (event.target.checked) {
        selected.push(event.target.value);
      } else {
        selected = selected.filter((c) => c !== event.target.value);
      }
      this.$emit('input', selected.length ? selected : undefined);
    },
  },
};
